import {Injectable} from '@angular/core'
import {Article, Poll} from '../interfaces/'
import {environment} from '../../environments/environment'
import {Observable} from 'rxjs'



import {HttpClient} from '@angular/common/http';

@Injectable()
export class CampaignsService {

  constructor(private http: HttpClient) {
  }

  /**
   * Recupero degli articoli
   * @param {number} page
   * @param {number} limit
   * @returns {Observable<Article[]>}
   */
  getAllArticles(page = 0): Observable<Article[]> {
    return this.http.get<Article[]>(environment.baseUrlWs + environment.wsVerison +
      'employer/campaigns/?page=' + page + '&type=article');
  }

  /**
   * Recupero di una singola campagna
   * @param {number} id
   * @returns {Observable<Object>}
   */
  getArticleById(id: number): Observable<Article> {
    return this.http.get<Article>(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + id)
  }

  /**
   * Metodo per il recupero di tutti i polls
   * @param {number} page
   * @param {number} limit
   * @returns {Observable<Poll[]>}
   */
  getAllPolls(page = 0): Observable<Poll[]> {
    return this.http.get<Poll[]>
    (environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/?page=' + page + '&type=poll');
  }

  /**
   * Metodo per il recupero di un signolo poll tramite id
   * @param {number} id
   * @returns {Observable<Poll>}
   */
  getPollById(id: number): Observable<Poll> {
    return this.http.get<Poll>(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + id);
  }

  /**
   * Crea una nuova campagna
   * @param formData
   * @param {string} type
   * @returns {Observable<any>}
   */
  createCampaign(formData: FormData, type: string): Observable<any> {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + type, formData);
  }

  /**
   * Crea un nuovo id per una campagna
   * @returns {Observable<any>}
   */
  createIdCampaign(type: String): Observable<any> {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/', {
      type: type.slice(0, -1) // Remove last char to match 'article' and 'poll'
    });
  }

  /**
   * Aggiorna una campagna esistente
   * @param {number} postid
   * @param {Object} postForm
   * @param {string} status
   * @param {string} type
   * @returns {Observable<any>}
   */
  updateCampaign(postid: number, postForm: FormData, status: string, type: string): Observable<any> {
    return this.http.put
    (environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + type + '/' + postid + '/' + status, postForm);
  }

  /**
   * Eliminia una campagna esistente
   * @param {number} id
   * @param {string} status
   * @returns {Observable<Object>}
   */
  deleteCampaign(id: number, status: string) {
    return this.http.delete(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + id + '/' + status);
  }

  /**
   * Associa un target ad una campagna
   * @param {number} idPost
   * @param {Object} target
   * @returns {Observable<any>}
   */
  createTarget(idPost: number, target: Object): Observable<any> {
    Object.keys(target).forEach(function(key) {
      if (target[key] === null) { delete target[key]; }
    });
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + idPost + '/target', target);
  }

  /**
   * Eliminia un target da una camapagna
   * @param {number} idPost
   * @param {number} idTarget
   * @param {any} queryParams
   * @returns {Observable<Object>}
   */
  deleteTarget(idPost: number, idTarget: number, queryParams: any) {
    return this.http.delete(environment.baseUrlWs + environment.wsVerison +
      'employer/campaigns/' + idPost + '/target/' + idTarget,  { params: queryParams });
  }

  statusCampaign(idPost: number, status: string) {
    return this.http.put(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + idPost + '/' + status, '');
  }

  launchPollCampaign(idPost: number) {
    return this.http.put(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/poll/' + idPost + '/launch', '');
  }

  /**
   * Lacia una campagna se il post non è mai stato pubblicato
   * @param {number} idPost
   * @param {string} type
   * @returns {Observable<Object>}
   */
  launchCampaign(idPost: number, type: string) {
    return this.http.put(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + type + '/' + idPost + '/launch', '');
  }

  /**
   * Mette in pausa una campagna se il post è pubblico
   * @param {number} idPost
   * @returns {Observable<Object>}
   */
  pauseCampaign(idPost: number) {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + idPost + '/pause', '');
  }

  /**
   * Fa ripartire una campagna se in pausa e gia pubblicata in precedenza
   * @param {number} idPost
   * @returns {Observable<Object>}
   */
  resumeCampaign(idPost: number) {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + idPost + '/resume', '');
  }

  /**
   * Recupera il post id di una campagna
   * (preview post)
   * @param idCamp
   * @returns {Observable<Object>}
   */
  getIdPostFromCampaigns(idCamp) {
    return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + idCamp + '/post-id')
  }


}
